import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ServiceNoteEventContainerModel, ServiceNoteIssueHdrContainerModel } from '../../../../../../models/aggregates/erp/rma';
import { Core2Config } from '../../shared/core2Config';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class FinancialItemsWithCategoriesService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/fi/financial-item-categories/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/fi/financial-item-categories/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/fi/financial-item-categories/backoffice-ep';
    this.httpClient = http;
  }
}
